import { Controller, useFormContext } from 'react-hook-form';
import { Selection } from '@quero-delivery/quero-components-web';
import { DefaultPillInput } from '@/_components/default-pill-input/default-pill-input';
import styles from './fare-district.module.scss';
import type { TypeFranchiseForm } from '../../types';
import { convertMoneyInputFormatToFloatWithNegative } from '@/Utils/FnUtils';

interface FareDistrictProps {
  index: number;
  canSwitchActiveStatus?: boolean;
}

export const FareDistrict = ({
  index,
  canSwitchActiveStatus = false,
}: FareDistrictProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<TypeFranchiseForm>();

  return (
    <div className={styles.container}>
      <div className={styles.upperRow}>
        <Controller
          name={`bairros.${index}.name`}
          control={control}
          render={({ field: { value } }) => {
            return <span>{value ? String(value).toUpperCase() : ''}</span>;
          }}
        />

        <Controller
          name={`bairros.${index}.isActive`}
          control={control}
          render={({ field: { value, onChange } }) => {
            return (
              <Selection
                type="switch"
                disabled={!canSwitchActiveStatus}
                checked={!!value}
                onClick={() => onChange(!value)}
                className={styles.switch}
              />
            );
          }}
        />
      </div>

      <div className={styles.inputsContainer}>
        <div className={styles.inputs}>
          <Controller
            name={`bairros.${index}.logFee`}
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <DefaultPillInput
                  containerClassName={styles.inputCustomContainer}
                  label="Taxa do log"
                  leftTag="R$"
                  value={value}
                  onChange={e => {
                    onChange(
                      convertMoneyInputFormatToFloatWithNegative(
                        e.target.value,
                      ),
                    );
                  }}
                  error={
                    Array.isArray(errors.bairros) &&
                    !!errors.bairros[index]?.logFee?.message
                  }
                  errorMessage={
                    Array.isArray(errors.bairros)
                      ? errors.bairros[index]?.logFee?.message
                      : undefined
                  }
                />
              );
            }}
          />
          <Controller
            name={`bairros.${index}.deliveryValue`}
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <DefaultPillInput
                  containerClassName={styles.inputCustomContainer}
                  label="Valor"
                  leftTag="R$"
                  value={value}
                  onChange={e => {
                    onChange(
                      convertMoneyInputFormatToFloatWithNegative(
                        e.target.value,
                      ),
                    );
                  }}
                  error={
                    Array.isArray(errors.bairros) &&
                    !!errors.bairros[index]?.deliveryValue?.message
                  }
                  errorMessage={
                    Array.isArray(errors.bairros)
                      ? errors.bairros[index]?.deliveryValue?.message
                      : undefined
                  }
                />
              );
            }}
          />
        </div>
        <div className={`${styles.inputs} ${styles.inputsLatLon}`}>
          <Controller
            name={`bairros.${index}.latitude`}
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <DefaultPillInput
                  containerClassName={`${styles.inputCustomContainer}`}
                  inputWrapperClassName={styles.addressInputWrapper}
                  label="Latitude"
                  value={value}
                  onChange={onChange}
                  disabled
                  error={
                    Array.isArray(errors.bairros) &&
                    !!errors.bairros[index]?.latitude?.message
                  }
                  errorMessage={
                    Array.isArray(errors.bairros)
                      ? errors.bairros[index]?.latitude?.message
                      : undefined
                  }
                />
              );
            }}
          />
          <Controller
            name={`bairros.${index}.longitude`}
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <DefaultPillInput
                  containerClassName={`${styles.inputCustomContainer}`}
                  inputWrapperClassName={styles.addressInputWrapper}
                  label="Longitude"
                  value={value}
                  onChange={onChange}
                  disabled
                  error={
                    Array.isArray(errors.bairros) &&
                    !!errors.bairros[index]?.longitude?.message
                  }
                  errorMessage={
                    Array.isArray(errors.bairros)
                      ? errors.bairros[index]?.longitude?.message
                      : undefined
                  }
                />
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};
